export default __webpack_public_path__ + "static/media/hht2_ep07_timeline_q01_a.62ea57f7.png";